var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 9,
    viewBox: "0 0 21 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43117 5.30056C5.94624 5.30056 6.3638 4.88301 6.3638 4.36793C6.3638 3.85286 5.94624 3.4353 5.43117 3.4353C4.91609 3.4353 4.49854 3.85286 4.49854 4.36793C4.49854 4.88301 4.91609 5.30056 5.43117 5.30056Z",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 0.621753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4053 5.30056C10.9204 5.30056 11.3379 4.88301 11.3379 4.36793C11.3379 3.85286 10.9204 3.4353 10.4053 3.4353C9.89021 3.4353 9.47266 3.85286 9.47266 4.36793C9.47266 4.88301 9.89021 5.30056 10.4053 5.30056Z",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 0.621753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3789 5.30056C15.894 5.30056 16.3115 4.88301 16.3115 4.36793C16.3115 3.85286 15.894 3.4353 15.3789 3.4353C14.8638 3.4353 14.4463 3.85286 14.4463 4.36793C14.4463 4.88301 14.8638 5.30056 15.3789 5.30056Z",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 0.621753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.df215832c5e7c66df8515132f3b8c2a6.svg";
export { ForwardRef as ReactComponent };